import React from 'react';
import { Box, InputAdornment, Typography } from '@mui/material';
import { BaseTextField } from '../../../Inputs';
import { Button } from '../../../Button';
import { ClickToCopy } from '../../../ClickToCopy';

const InstructionList: React.FC = (props) => <Box component="ol" sx={{ pl: 2, m: 0 }} {...props} />;

const InstructionLine: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Typography component="li" sx={{ mb: 2 }}>
    {children}
  </Typography>
);


export const InstructionGoogleCalendar: React.FC<{ icsLink: string }> = ({ icsLink }) => {
  return (
    <Box>
      <Box sx={{ mb: 2 }}>
        <Box mb={1}>
          <strong>Subscription URL:</strong>
        </Box>
        <BaseTextField
          fullWidth value={icsLink} color="secondary" size="small"
          slotProps={{
            input: {
              readOnly: true,
              endAdornment: (
                <InputAdornment position="end">
                  <ClickToCopy text={icsLink} />
                </InputAdornment>
              )
            }
          }}
        />
      </Box>
      <InstructionList>
        <InstructionLine>Open <strong>Google Calendar</strong> on your computer.</InstructionLine>
        <InstructionLine>In the left menu, find <strong>“Other calendars”</strong> and click the <strong>+</strong> icon.</InstructionLine>
        <InstructionLine>Select <strong>“From URL.”</strong></InstructionLine>
        <InstructionLine>Paste your subscription link into the <strong>URL of calendar</strong> field.</InstructionLine>
        <InstructionLine>Click <strong>“Add calendar”</strong> to finish.</InstructionLine>
      </InstructionList>
    </Box>
  );
};


export const InstructionAppleCalendar: React.FC<{ icsLink: string }> = ({ icsLink }) => {
  return (
    <Box>
      <Box sx={{ mb: 2 }}>
        <Box mb={1}>
          <strong>Subscription URL:</strong>
        </Box>
        <BaseTextField
          fullWidth value={icsLink} color="secondary" size="small"
          slotProps={{
            input: {
              readOnly: true,
              endAdornment: (
                <InputAdornment position="end">
                  <ClickToCopy text={icsLink} />
                </InputAdornment>
              )
            }
          }}
        />
      </Box>
      <InstructionList>
        <InstructionLine>Open the <strong>Calendar</strong> app.</InstructionLine>
        <InstructionLine>In the top menu, go to <strong>File</strong> → <strong>New Calendar Subscription</strong>.</InstructionLine>
        <InstructionLine>Paste your subscription link into the <strong>Calendar URL</strong> field.</InstructionLine>
        <InstructionLine>Click <strong>Subscribe</strong>.</InstructionLine>
        <InstructionLine>
          Adjust your settings:
          <Box component="ul" sx={{ marginTop: '8px', pl: 3 }}>
            <li>Calendar name</li>
            <li>Color</li>
            <li>Auto-refresh frequency</li>
          </Box>
        </InstructionLine>
        <InstructionLine>Click <strong>OK</strong> to confirm.</InstructionLine>
      </InstructionList>
    </Box>
  );
};

export const InstructionNativeCalendarWithLinkButton: React.FC<{ icsLink: string }> = ({ icsLink }) => {
  return (
    <Box>
      <Box sx={{ mb: 2 }}>
        Click the button below to open your default calendar app and add this subscription.
      </Box>
      <Button fullWidth variant="contained" color="secondary" component="a" href={icsLink}>Subscribe to calendar</Button>
    </Box>
  );
};
